module.exports = __webpack_public_path__ + "img/hk.5dc61719.png";